var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cell-tooltip",style:({ backgroundColor: _vm.color })},[_c('p',[(_vm.showCurrency)?_c('span',[_vm._v("€")]):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.value))]),(_vm.showPercentage)?_c('span',[_vm._v("%")]):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }